module.exports = __webpack_public_path__ + "img/pool.811d2144.svg";